/**
 * Checks if the clicked target is the vertical scrollbar thumb.
 *
 * @param {(Element | EventTarget | null)} target : should be e.target from onClick or whatever listener from <ScrollArea> component
 * @returns {boolean}
 */
export const clickedOnVerticalScrollbar = (target: Element | EventTarget | null) => {
    const verticalScrollbarElement =
        target instanceof Element &&
        target.parentElement?.classList.contains("mantine-ScrollArea-scrollbar") &&
        target.parentElement?.getAttribute("data-orientation") === "vertical";

    if (verticalScrollbarElement && target.classList.contains("mantine-ScrollArea-thumb")) {
        return true;
    }

    return false;
};
